class CollectionSwitcher extends HTMLElement {
  connectedCallback() {
    this.#centerActiveLink();
    this.addEventListener('keydown', this.#handleKeydown);
  }

  disconnectedCallback() {
    this.removeEventListener('keydown', this.#handleKeydown);
  }

  #centerActiveLink() {
    const activeLink = this.querySelector('[aria-current="page"]');
    const scroller = this.querySelector('.collection-switcher__nav');

    if (!(activeLink instanceof HTMLElement) || !(scroller instanceof HTMLElement)) return;
    if (scroller.scrollWidth <= scroller.clientWidth) return;

    requestAnimationFrame(() => {
      const targetLeft = activeLink.offsetLeft - (scroller.clientWidth - activeLink.offsetWidth) / 2;
      scroller.scrollTo({ left: Math.max(0, targetLeft), behavior: 'instant' });
    });
  }

  #handleKeydown = (event) => {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

    const links = Array.from(this.querySelectorAll('.collection-switcher__link'));
    const currentIndex = links.indexOf(document.activeElement);

    if (currentIndex < 0) return;

    event.preventDefault();
    const direction = event.key === 'ArrowRight' ? 1 : -1;
    const nextIndex = (currentIndex + direction + links.length) % links.length;
    links[nextIndex]?.focus();
  };
}

if (!customElements.get('collection-switcher')) {
  customElements.define('collection-switcher', CollectionSwitcher);
}
